<div class="warning-rule-container">
  <mat-accordion *ngIf="warningRuleSkeletons && warningRuleSkeletons.length > 0">
    <mat-expansion-panel>
      <mat-expansion-panel-header>Warning Rules</mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let warningRule of warningRuleSkeletons"
            (opened)="onOpened(warningRule.warningRuleId)"
          >
            <mat-expansion-panel-header>
              {{ warningRule.warningRuleId }}
              <span *ngIf="warningRule.isDeleted">&nbsp;(Deleted)</span>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <div *ngIf="warningRuleAuditLoading; else warningRuleAuditsLoaded">Loading...</div>
              <ng-template #warningRuleAuditsLoaded>
                <div
                  *ngIf="
                    warningRuleAudits && warningRuleAudits.length > 0;
                    else noWarningRuleAudits
                  "
                >
                  <sd-portal-audit-detail-list
                    [audits]="warningRuleAudits"
                    (nextPage)="onNextPage(warningRule.warningRuleId)"
                  ></sd-portal-audit-detail-list>
                </div>
                <ng-template #noWarningRuleAudits>
                  No audit records for this warning rule
                </ng-template>
              </ng-template>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
